"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _attachments = require('shared/constants/attachments');

// The most files named before the rest are only counted.
const NAMED = 3

/* Tells the user which files were left out because one send carries at most
 * MAX_ATTACHMENTS_PER_SEND: "You can attach up to 20 files at a time. Not
 * added: a.jpg, b.jpg, c.jpg and 2 more." */
 const describeAttachmentsNotAdded = (names) => {
  const named = names.slice(0, NAMED).join(', ')
  const more = names.length > NAMED ? ` and ${names.length - NAMED} more` : ''
  return `You can attach up to ${_attachments.MAX_ATTACHMENTS_PER_SEND} files at a time. Not added: ${named}${more}.`
}; exports.describeAttachmentsNotAdded = describeAttachmentsNotAdded
